import { Injectable } from '@angular/core';

import { CondicaoPagamentoPrazo } from '../condicao-pagamento-prazo';
import { toFixed } from '../../../../core/services/utils/numbers';

@Injectable({
    providedIn: 'root'
})
export class CondicaoPagamentoPrazoCalculoService {

    /** Calcula o prazo médio dos prazos da condição de pagamento */
    calcularPrazoMedio(entities: CondicaoPagamentoPrazo[]) {
        if (!entities) {
            return 0;
        }

        // Somando todos os prazos informados
        let totalDosPrazos = 0;
        let quantidadeDePrazos = 0;
        entities.forEach(entity => {
            // Consideramos somente os prazos que tiverem o valor informado
            if (entity.prazo && !isNaN(entity.prazo)) {
                quantidadeDePrazos++;
                totalDosPrazos +=  Number(entity.prazo);
            }
        });
        if (quantidadeDePrazos === 0) {
            return 0;
        }

        // Fórmula do prazo médio
        const prazoMedio =  totalDosPrazos / quantidadeDePrazos;
        return toFixed(prazoMedio, 0);
    }
}
